import {Vue} from '../../app.vues';

import SwbServcWorkVoucherDetail from './ServcWorkVoucherDetail';
import SwbServcWorkVoucherRecList from './ServcWorkVoucherRecList';
import SwbServcWorkStaffQualiList from './ServcWorkStaffQualiList';
// -------- 基于设备 [查看维保记录] --------
import SwbDeviceMaintPlanDetail from './DeviceMaintPlanDetail';
import SwbDeviceRepairRec from './DeviceRepairRec';
// 设备检验信息
import SwbDevcInspectInfo from './DevcInspectInfo';
Vue.regist(SwbServcWorkVoucherDetail);
Vue.regist(SwbServcWorkVoucherRecList);
Vue.regist(SwbServcWorkStaffQualiList);
Vue.regist(SwbDevcInspectInfo);
Vue.regist(SwbDeviceMaintPlanDetail);
Vue.regist(SwbDeviceRepairRec);

export function openWorkVoucherDetailDlg(voucherId, callback) {
    //
    Vue.$showDialog({
        title: '服务工单 - 详情',
        width: -400,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-detail :voucherId = "voucherId" ref="swb_servc_work_voucher_detail"></swb-servc-work-voucher-detail>' +
        '</div>',
        data: {
            voucherId: null
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}

import SwbServcWorkVoucherPdf from './ServcWorkVoucherPdf'
Vue.regist(SwbServcWorkVoucherPdf);

export function openWorkVoucherPdfDlg(voucherId) {
    Vue.$showDialog({
        title: '服务工单 - 打印',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-servc-work-voucher-pdf :voucherId = "voucherId" ref="swb_servc_work_voucher_pdf"></swb-servc-work-voucher-pdf>',
        data: {
            voucherId: voucherId
        }
    });
}


export function openWorkVoucherRecsDlg(voucherId, callback) {
    //
    Vue.$showDialog({
        title: '服务工单 - 操作记录',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-rec-list :voucherId = "voucherId" ref="swb_servc_work_voucher_rec_list"></swb-servc-work-voucher-rec-list>' +
        '</div>',
        data: {
            voucherId: null
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}

export function openDeviceRepairRecDlg(tmpNo) {
    Vue.$showDialog({
        title: '维保记录',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-device-repair-rec-info :tmpNo = "tmpNo" ref="swb_device_repair_rec_info"></swb-device-repair-rec-info>',
        data: {
            tmpNo: tmpNo
        },
        okClicked: function () {
        }
    });
}

import SwbDeviceRepairRecList from './DeviceRepairRecList';
Vue.regist(SwbDeviceRepairRecList);
// 维保记录
export function openDeviceRepairRecListDlg(prams) {
    let title = prams["title"] || "保养记录 - 查看";
    let servcType = prams["servcType"] || getEnumInfoWith('servcType', 'name', 'ProductMaint').value;
    if (servcType == 6) {
        title = "检验记录 - 查看";
    }
    let planId = prams["planId"] || null;
    let tmpNo = prams["tmpNo"] || null;
    Vue.$showDialog({
        title: title,
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-device-repair-rec-list :planId="planId" :tmpNo = "tmpNo" :servcType="servcType" ref="swb_device_repair_rec_list"></swb-device-repair-rec-list>',
        data: {
            planId: planId,
            tmpNo: tmpNo,
            servcType: servcType
        },
        okClicked: function () {
        }
    });
}

// 设备保养计划详情dlg
export function showDeviceMainPlanDetailDialog(id) {
    Vue.$showDialog({
        title: "保养计划 - 详情",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-device-maint-plan-detail :id="id" ref="swb_device_maint_plan_detail"></swb-device-maint-plan-detail>',
        data: {
            id: id
        },
        okClicked: function () {
        }
    });
}

export function openDevcInspectInfoDlg(workVoucherId) {
    Vue.$showDialog({
        title: '设备检验信息 - 详情',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-inspect-info :workVoucherId = "workVoucherId" ref="swb_servc_work_voucher_detail"></swb-devc-inspect-info>',
        data: {
            workVoucherId: workVoucherId
        },
        okClicked: function () {
        },
    });
}

export function openServcWorkStaffQualiDlg(voucherId) {
    Vue.$showDialog({
        title: '工单人员要求资质',
        width: 800,
        height: 600,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-servc-work-staff-quali-list :voucherId="voucherId"></swb-servc-work-staff-quali-list>',
        data: {
            voucherId: voucherId
        },
        okClicked: function () {
        }
    });
}

import SwbShopAsmblAccIoRecSet from './ShopAsmblAccIoRecSet';
Vue.regist(SwbShopAsmblAccIoRecSet);

// 组装件使用
export function showAsmblAccStockSetSelectDlg(params, callback) {
    let shopDevcId = params["shopDevcId"] || null;
    let theDlg = Vue.$showDialog({
        title: "组装信息",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-shop-asmbl-acc-io-rec-set :shopDevcId="shopDevcId" ref="swb_shop_asmbl_acc_io_rec_set"></swb-shop-asmbl-acc-io-rec-set>',
        data: {
            shopDevcId: shopDevcId
        }
    });
}

import SwbServcWorkVoucherDlgtList from './ServcWorkVoucherDlgtList'
Vue.regist(SwbServcWorkVoucherDlgtList);
// 维保查看
export function openServcWorkVoucherDlgtdDlg(voucherId, callback) {
    //
    Vue.$showDialog({
        title: '委托工单 - 查看',
        width: -200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-dlgt-list :masterId = "voucherId" ref="swb_servc_work_voucher_dlgt_list"></swb-servc-work-voucher-dlgt-list>' +
        '</div>',
        data: {
            voucherId: null
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/workVoucher/showDetailDlg.js
// module id = 46
// module chunks = 1